import {Outlet} from "react-router-dom";
import NavBar from "./NavBar";
import React from "react";
import Footer from "./Footer";

const Layout = () => {
    return <div>
        <NavBar/>
        <Outlet/>
        <Footer/>
    </div>
}

export default Layout;